import React from 'react';

import { Grid, Divider } from '@material-ui/core';

export const CustomDivider = () => {
  return (
    <Grid item xs={12} component={Divider} />
  )
}
